import { useAppSelector } from 'application/providers/StoreProvider';
import { selectIsBillingEnabled } from 'application/store';

export const useAccountCompanyIsBillingEnabled = () => {
  const isBillingEnabled = useAppSelector(selectIsBillingEnabled);

  return isBillingEnabled;
};
